export default __webpack_public_path__ + "static/media/combine.2c44d305.jpeg";